module.exports = __webpack_public_path__ + "static/media/stress@2x.b47b63a1.png";